import { DRAFT_BOOKMARK } from './draftBookmark';

// The marker in any form Outlook returns it. Substring-matched — see
// draftBookmark.ts.
const DRAFT_MARKER_SELECTOR = `[class*="${DRAFT_BOOKMARK}"], a[name*="${DRAFT_BOOKMARK}"], [style*="mso-bookmark:${DRAFT_BOOKMARK}"]`;

export function bodyContainsDraftMarker(html: string): boolean {
  return html.includes(DRAFT_BOOKMARK);
}

// Removes the previous draft's wrapper and children; returns a body fragment.
export function stripPreviousGeneratedDraft(html: string): string {
  if (!html.includes(DRAFT_BOOKMARK)) return html;

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const markers = doc.querySelectorAll(DRAFT_MARKER_SELECTOR);
    if (markers.length === 0) return html;

    markers.forEach((el) => el.remove());

    return doc.body.innerHTML;
  } catch {
    return html;
  }
}

// What to keep below a freshly inserted draft on re-generate: the signature
// (lifted out of its wrappers via .outerHTML) plus anything after it. We
// rebuild flat instead of re-setting Outlook's returned markup, which Outlook
// re-wraps and re-prefixes each round-trip, making the reply drift (deeper
// nesting, creeping blank lines). Falls back to the stripped body when there's
// no signature, so content is never dropped.
export function replyTailToPreserve(replyHtml: string): string {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(replyHtml, 'text/html');

    doc.querySelectorAll(DRAFT_MARKER_SELECTOR).forEach((el) => el.remove());

    const signature = doc.querySelector('[id*="Signature"]');
    if (!signature) return doc.body.innerHTML;

    let tail = '';
    let node: Element | null = signature;
    while (node) {
      tail += node.outerHTML;
      node = node.nextElementSibling;
    }

    return tail;
  } catch {
    return stripPreviousGeneratedDraft(replyHtml);
  }
}
